import type { RetrievalContext, WebSourceDocument, SourceDocument } from 'src/types/llm';

export function mergeSources(sources: SourceDocument[]): SourceDocument[] {
	return sources.reduce((acc, val) => {
		const i = acc.findIndex((c) => c.doc_id === val.doc_id);
		if (i > -1) {
			// Merge chunk_ids, deduplicating
			const mergedIds = [...new Set([...acc[i].chunk_ids, ...val.chunk_ids])];
			acc[i] = { ...acc[i], chunk_ids: mergedIds };
			return acc;
		}
		acc.push(val);
		return acc;
	}, [] as SourceDocument[]);
}

export function mergeRetrievalContext(
	existing: RetrievalContext | undefined,
	incoming: RetrievalContext
): RetrievalContext {
	if (!existing) {
		return incoming;
	}
	const existingDocs = existing.documents ?? [];
	const existingDocIds = new Set(existingDocs.map((d) => d.id));
	const newDocs = incoming.documents.filter((d) => !existingDocIds.has(d.id));

	const existingChunks = existing.chunks ?? [];
	const existingChunkIds = new Set(existingChunks.map((c) => c.id));
	const newChunks = incoming.chunks.filter((c) => !existingChunkIds.has(c.id));

	return {
		documents: [...existingDocs, ...newDocs],
		chunks: [...existingChunks, ...newChunks]
	};
}

export function mergeWebSources(
	sources: WebSourceDocument[]
): WebSourceDocument[] {
	return sources.reduce((acc, val) => {
		const exists = acc.some((s) => s.id === val.id);
		if (!exists) acc.push(val);
		return acc;
	}, [] as WebSourceDocument[]);
}
